// extracted by mini-css-extract-plugin
export default {"button":"_CTAButtonStyles_button__LzSRt","outline-button":"_CTAButtonStyles_outline-button__5UZAG","ghost-button":"_CTAButtonStyles_ghost-button__2CFx-"};